import { Component, OnInit } from '@angular/core';

import { Router } from '@angular/router';
import { AuthService } from 'my-lib-sanfelici';


@Component({
  selector: 'app-anonymous',
  templateUrl: './anonymous.component.html',
  styleUrls: ['./anonymous.component.css']
})
export class AnonymousComponent implements OnInit {
  usr: firebase.User;
  constructor(
    public  authservice: AuthService,
    private router: Router) {

     }
accediAnonymous(){
  this.authservice.anonymousLogin().then(u=>{
    console.log('u'+u);
  }).catch(err=>{
    console.log('err'+err);
  });
}
logout(){
  this.authservice.logout().then(u=>{
    console.log(u)
  }).catch(err=>{
    console.log('err'+err);
  });
}
  ngOnInit() {
    this.authservice.usr.subscribe(u => this.usr = u);

}
}
